import { Form, message, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { dictsGetPaymentVids } from "../../extensions/dicts";
import { isMobile } from "@/extensions/design";

const PaymentZReport = ({ onClose }) => {
  const [loading, setLoading] = useState(false);
  const [vid, setVid] = useState();
  const [form] = Form.useForm();
  const [vidPayments, setVidPayments] = useState([]);

  useEffect(() => { dictsGetPaymentVids(setVidPayments); }, [])

  const onSave = () => {
    setLoading(true);
    serverFetch(`ticket/zreport/${vid}`, {method: "POST"})
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  return <Modal title="Печатать Z отчет" open 
    onCancel={() => onClose(false)} onOk={onSave} okText="ОК" cancelText="Отмена" width={400} okButtonProps={{disabled: !vid, style: isMobile ? { width: "100%" } : undefined,}}
    loading={loading} cancelButtonProps={isMobile ? { style: { display: "none" } } : {}}
  >
    <Form form={form} colon={false} layout={ isMobile ? "inline" : ""}>
      <Form.Item label="Вид оплаты" name="vid" className={ isMobile ? "records-form-item-mobile" : ""}>
        <Select options={vidPayments} onChange={e => setVid(e)} className={ isMobile ? "records-form-item-mobile" : ""}/>
      </Form.Item>
    </Form>
  </Modal>
}

export default PaymentZReport;